import { render } from "./UMiLogo.vue?vue&type=template&id=26526e4c"
import script from "./UMiLogo.vue?vue&type=script&lang=js"
export * from "./UMiLogo.vue?vue&type=script&lang=js"

import "./UMiLogo.vue?vue&type=style&index=0&id=26526e4c&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__